export const MUTATION_DELETE_MD_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteMietendeckelCase(id: $id)
	}
`;
